import React from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import {
  FaEllipsisH,
  FaComments,
  FaShareAlt,
  FaRegThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
  FaThumbsUp,
} from "react-icons/fa";
import YoutubeEmbed from "./YoutubeEmbed";
import UserAvatar from "./UserAvatar";
import "./styles/WallFeed.css";

export function getEmbedId(url) {
  if (!url) return false;
  const array = url.split(" ");
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if (element.indexOf("https://") >= 0) {
      const match = element.match(regExp);
      if (match && match[7].length === 11) {
        return match[7];
      }
    }
  }
  return false;
}

export function getLocationLabel(ad) {
  if (!ad || !ad.State) return "";
  return [ad.State, ad.City].filter(Boolean).join(", ");
}

class CommentPostCard extends React.Component {
  state = { menuOpen: false };

  toggleMenu = () => {
    this.setState((state) => ({ menuOpen: !state.menuOpen }));
  };

  closeMenu = () => {
    this.setState({ menuOpen: false });
  };

  handleMenuAction = (action) => {
    this.closeMenu();
    action();
  };

  render() {
    const {
      comment,
      user_id,
      featured = false,
      showThreadActions = false,
      onClickUp,
      onClickDown,
      onClickRemove,
      onClickReport,
      onClickSetItemComment,
    } = this.props;

    if (!comment?.Id) return null;

    const isUp = comment.Like === 1;
    const isDown = comment.Like === 0;
    const embedId = getEmbedId(comment.Text);
    const location = getLocationLabel(comment.Ad);
    const subComments =
      comment.CountSubComment ?? comment.Count_subcomment ?? 0;
    const isOwner = comment.UserId?.toString() === user_id;

    return (
      <article
        className={`wall-post-card${featured ? " comment-post-card--featured" : ""}`}
      >
        <header className="wall-post-header">
          <UserAvatar
            src={comment.Avatar}
            alt={comment.Name}
            verified={comment.Verified}
            user={comment}
            size="md"
            imgClassName="wall-post-avatar"
            initials={(comment.Name || "?").charAt(0).toUpperCase()}
          />
          <div className="wall-post-meta">
            <p className="wall-post-name">
              {comment.HasStore && comment.Store?.Id ? (
                <Link to={`/marketstore/show/${comment.Store.Id}`}>
                  {comment.Name}
                </Link>
              ) : (
                <span>{comment.Name}</span>
              )}
            </p>
            <div className="wall-post-submeta">
              {location && <span>{location}</span>}
              {comment.CreatedAt && <span>{comment.CreatedAt}</span>}
            </div>
          </div>
          {(onClickRemove || onClickReport) && (
            <div className="wall-post-menu">
              <button
                type="button"
                className="wall-post-menu-btn"
                aria-label="Options"
                onClick={this.toggleMenu}
                onBlur={() => setTimeout(this.closeMenu, 150)}
              >
                <FaEllipsisH />
              </button>
              {this.state.menuOpen && (
                <ul className="wall-post-menu-dropdown">
                  <li>
                    <button
                      type="button"
                      onMouseDown={() =>
                        this.handleMenuAction(
                          isOwner ? onClickRemove : onClickReport
                        )
                      }
                    >
                      <Translate
                        value={isOwner ? "comment_remove" : "comment_report"}
                      />
                    </button>
                  </li>
                </ul>
              )}
            </div>
          )}
        </header>

        <div className="wall-post-body">
          {embedId && <YoutubeEmbed embedId={embedId} />}
          {comment.Text && <p className="wall-post-text">{comment.Text}</p>}
          {comment.Ad?.Name && (
            <span className="wall-post-ad-name">{comment.Ad.Name}</span>
          )}
          {comment.HasMedia && (
            <div className="wall-post-media">
              <Link to="/galery">
                <img src={comment.Media} alt="" />
              </Link>
            </div>
          )}
          {comment.Ad?.Id && comment.Ad?.Photo && (
            <Link
              to={`/goder/show/${comment.Ad.Id}`}
              className="wall-post-ad-link"
            >
              <img src={comment.Ad.Photo} alt={comment.Ad.Name || ""} />
            </Link>
          )}
        </div>

        <footer className="wall-post-footer">
          {showThreadActions && (
            <div className="wall-post-actions">
              <Link
                to={`/comment/${comment.Id}`}
                className="wall-post-action-btn"
                onClick={onClickSetItemComment}
              >
                <FaComments />
                <span>{subComments}</span>
              </Link>
              <button type="button" className="wall-post-action-btn">
                <FaShareAlt />
                <span>{comment.CountShare ?? 0}</span>
              </button>
            </div>
          )}

          <div className="wall-post-like-bar">
            <button
              type="button"
              className={`wall-post-like-btn${isUp ? " is-active-up" : ""}`}
              onClick={onClickUp}
            >
              {isUp ? <FaThumbsUp /> : <FaRegThumbsUp />}
              <span>{comment.CountLike}</span>
            </button>
            <span className="wall-post-like-divider" />
            <button
              type="button"
              className={`wall-post-like-btn${isDown ? " is-active-down" : ""}`}
              onClick={onClickDown}
            >
              {isDown ? <FaThumbsDown /> : <FaRegThumbsDown />}
              <span>{comment.CountUnlike}</span>
            </button>
          </div>
        </footer>
      </article>
    );
  }
}

export default CommentPostCard;
